export const ERROR_IMPORT = "[ERROR] import locale file:";
